export default {
  OFFER_CARD: 'OFFER CARD',
  OFFER_CARD_PRIMARY: 'OFFER CARD PRIMARY',
  OFFER_CARD_SECONDARY: 'OFFER CARD SECONDARY',
  SMART_AWARD: 'SMART AWARD',
  RESERVE_PRICE_BANNER: 'RESERVE PRICE BANNER',
  SUGGESTED_NEGOTIATION: 'SUGGESTED NEGOTIATION',
};
